import { useNavigate } from "react-router-dom";
import BottomFixedModal from "@src/components/common/bottomFixedModal/BottomFixedModal";
import { closeWebview } from "@src/utils/route";
import Blank from "@src/components/common/blank/Blank";
import { postRecommendHallInquiryChat } from "@src/api/weddingHall/chat";

import "./stopRecommend.scss";

type Props = {
  showStopModal: boolean;
  setShowStopModal: (bool: boolean) => void;
  hallName?: string;
};

const StopRecommend = ({
  showStopModal,
  setShowStopModal,
  hallName = "",
}: Props) => {
  const navigate = useNavigate();
  return (
    <BottomFixedModal
      className="realtime-cancel-bottomsheet"
      isShow={showStopModal}
      isTransition={true}
      title={"😥"}
      hideModal={() => setShowStopModal(false)}
    >
      <div className="realtime-cancel-noti-wrap">
        <div className="noti-wrap">
          <p className="title bold">
            {`희망 조건을 정하는 것부터 어려우신가요?\n웨딩홀 전문 매니저에게 문의해 보세요.`}
          </p>
          <p className="desc">
            웨딩홀 알아보기 전 희망 조건을 정하는 꿀팁부터, 두 분에게 딱 맞는 웨딩홀 추천 리스트까지 정리해 드려요.
          </p>
          <Blank height={80} />
          <div className="cancel-btn-wrap">
            <button
              className="btn cancel-btn btn-full btn-red0"
              onClick={() => {
                closeWebview();
              }}
            >
              나중에
            </button>
            <button
              className="btn cancel-btn btn-full btn-red500"
              onClick={() => {
                postRecommendHallInquiryChat()
                  .then((res) => {
                    navigate(`/mypage/chat`);
                  })
                  .catch((err) => {
                    console.error(err);
                  });
              }}
            >
              1:1 채팅 문의
            </button>
          </div>
        </div>
      </div>
    </BottomFixedModal>
  );
};

export default StopRecommend;
